<div class="tbcds-tooltip d-flex" #tooltip="matTooltip" (click)="tooltip.toggle(); $event.stopImmediatePropagation(); $event.preventDefault();" matTooltip="{{tip}}" matTooltipPosition="above">
    <img src="/assets/images/tooltip.svg" alt="">
    <ng-content></ng-content>
</div>